import { Result as AntdResult, ResultProps as AntdResultProps } from 'antd'

interface ResultProps extends AntdResultProps {
  label?: string
}

export const Result = (props: ResultProps) => {
  const { label } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: 200, justifyItems: 'flex-end' }}>
        {label && <span>{label}:</span>}
      </div>
      <div style={{ width: '100%' }}>
        <AntdResult {...props} />
      </div>
    </div>
  )
}

Result.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 20
  }
}
